export const formatImageUrl = (url: string, sizePx = 220) => {
  if (/^https?:\/\//.test(url)) {
    return url;
  }

  return `https://static.wixstatic.com/media/${url}/v1/fit/w_${sizePx},h_${sizePx},q_90/file.jpg`;
};
